export default __webpack_public_path__ + "static/media/iread7.d452599c.jpeg";